import { SearchOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useMemoizedFn } from 'ahooks';
import { Input, Tabs } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';

const SearchWrap = styled.div`
  width: 230px;
`;
const GroupNavTabs = styled(Tabs)`
  .ant-tabs-nav {
    padding: 0 16px 0 24px;
  }

  .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-tab {
    padding: 17px 0;
  }
`;

export interface GroupTypeNavProps {
  activeKey?: string;
  onChange: (value: Phrase.Group['groupType']) => void;
  onSearch?: (keyword?: string) => void;
}

const GroupTypeNav = (props: GroupTypeNavProps) => {
  const { activeKey, onChange, onSearch } = props;
  const { t } = useTranslate();
  const [inputValue, setInputValue] = useState('');

  const groupLabelMap = useMemo(
    () => ({
      PERSONAL: t('groupType.PERSONAL'),
      TEAM: t('groupType.TEAM'),
    }),
    [t],
  );

  const tabItems = useMemo(() => {
    return Object.keys(groupLabelMap).map((cur) => {
      const { [cur]: label } = groupLabelMap;
      return <Tabs.TabPane tab={label} key={cur} />;
    });
  }, [groupLabelMap]);

  const handleChange = useMemoizedFn((activeKey: string) => {
    onChange(activeKey as Phrase.Group['groupType']);
  });

  const handleInputChange = useMemoizedFn((e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  });

  return (
    <GroupNavTabs
      activeKey={activeKey}
      tabBarExtraContent={{
        right: (
          <SearchWrap>
            <Input
              value={inputValue}
              onChange={handleInputChange}
              placeholder={t('phrase.快捷键搜索')}
              suffix={<SearchOutlined onClick={() => onSearch?.(inputValue)} />}
              onPressEnter={() => onSearch?.(inputValue)}
              allowClear
            />
          </SearchWrap>
        ),
      }}
      onChange={handleChange}
    >
      {tabItems}
    </GroupNavTabs>
  );
};

export default GroupTypeNav;
